import { useEffect, useState } from "react";
import { CTeEventoDto } from "./CTe.Evento.Dto";
import { showToast } from "src/componentes";
import {
  CTeEventoEnviar,
  CTeEventoExcluir,
  CTeEventoFiltrar,
} from "src/services/Fiscal.Service";
import { useSearchParams } from "react-router-dom";
import { MapearErrosServidor } from "src/hook/Functions";

const CTeEventoCode = () => {
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<CTeEventoDto[]>([]);
  const [searchParams] = useSearchParams();
  const [modalShowPropriedades, setModalShowPropriedades] = useState(false);
  const [modalShowCadastro, setModalShowCadastro] = useState(false);
  const [evento, setEvento] = useState<CTeEventoDto>();

  const cteId = Number(
    searchParams.get("cteId") ?? searchParams.get("cTeId") ?? 0
  );

  const onShowModalCadastro = (show: boolean) => setModalShowCadastro(show);
  const onReturnModalPropriedades = () => setModalShowPropriedades(false);

  useEffect(() => {
    const controller = new AbortController();
    const load = async () => {
      setLoading(true);
      await filtrar(cteId).finally(() => setLoading(false));
    };
    if (cteId > 0) {
      load();
    }
    return () => {
      controller.abort();
    };
  }, [cteId]);

  const filtrar = async (idCte: number) => {
    if (!idCte) return;
    try {
      const response = await CTeEventoFiltrar({ cTeId: idCte });
      if (response.data.success) {
        setData(response.data.data);
      } else {
        MapearErrosServidor(response.data.notifications, showToast);
      }
    } catch (error) {
      console.error("Erro ao buscar eventos do CT-e:", error);
      showToast({
        message: "Ocorreu erro ao buscar dados dos eventos",
        title: "Erro",
        variant: "Danger",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleClickPropriedades = (value: CTeEventoDto) => () => {
    setModalShowPropriedades(true);
    setEvento(value);
  };

  const onSendModalPropriedades = async (value: CTeEventoDto) => {
    onReturnModalPropriedades();
    setLoading(true);
    try {
      const response = await CTeEventoEnviar(value.id);
      if (response.data.success === true) {
        await filtrar(cteId);
        showToast({
          message: "Evento enviado com sucesso",
          title: "Sucesso",
          variant: "Success",
        });
      }
      MapearErrosServidor(response.data.notifications, showToast);
    } catch (error) {
      console.error("Erro ao enviar evento:", error);
      showToast({
        message: "Ocorreu erro ao enviar evento",
        title: "Erro",
        variant: "Danger",
      });
    } finally {
      setLoading(false);
    }
  };

  const onDeleteModalPropriedades = async (value: CTeEventoDto) => {
    setLoading(true);
    try {
      const response = await CTeEventoExcluir(value.id);
      if (response.data.success === true) {
        await filtrar(cteId);
        showToast({
          message: "Evento excluído com sucesso",
          title: "Sucesso",
          variant: "Success",
        });
      }
      MapearErrosServidor(response.data.notifications, showToast);
    } catch (error) {
      console.error("Erro ao excluir evento:", error);
      showToast({
        message: "Ocorreu erro ao excluir evento",
        title: "Erro",
        variant: "Danger",
      });
    } finally {
      setLoading(false);
    }
  };

  const onReloadModalPropriedades = async () => {
    setLoading(true);
    await filtrar(cteId).finally(() => setLoading(false));
  };

  return {
    loading,
    data,
    modalShowPropriedades,
    onReturnModalPropriedades,
    evento,
    handleClickPropriedades,
    onSendModalPropriedades,
    onShowModalCadastro,
    modalShowCadastro,
    cteId,
    onDeleteModalPropriedades,
    onReloadModalPropriedades,
  };
};

export default CTeEventoCode;
